import React from 'react'
import PointsSvg from 'images/Points.svg'
import CreditsSvg from 'images/Credits.svg'
import PatternPacksSvg from 'images/Pattern_Packs.svg'
import { Link } from 'react-router-dom'
import { CREDITS_URL, PROFILE_PATTERN_PACKS_URL, PROFILE_REWARDS_URL } from '../../../urls'
import { useMeQuery } from '@graphql/queries/__generated__/me.generated'
import { useQueryParams } from 'use-query-params'
import { GlobalDialogFormsParams } from '@components/GlobalDialogForms'
import { SHORT_SITE_NAME } from '../../../../constants'
import { useTranslation } from 'react-i18next'

interface SpecialFeaturesProps {}

const SpecialFeatures: React.FC<SpecialFeaturesProps> = ({}) => {
  const { t } = useTranslation()
  const [, setParams] = useQueryParams(GlobalDialogFormsParams)
  const meQuery = useMeQuery({
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
  })
  const isAuthenticated = !!meQuery.data?.me
  const handleSignUp = (pathname: string) => e => {
    e.preventDefault()
    setParams({ global_dialog_form: 'signIn', redirect: pathname }, 'replaceIn')
  }
  return (
    <section className='my-40'>
      <h3 className='font-bold text-5xl font-futura text-center my-40 mb-30'>
        {t('title.specialFeatures', 'Special features for registered members.')}
      </h3>
      <div className='flex items-center justify-center flex-wrap'>
        <Link
          to={PROFILE_REWARDS_URL}
          onClick={!isAuthenticated ? handleSignUp(PROFILE_REWARDS_URL) : undefined}
          className='flex w-350 max-w-full m-10 p-10 border border-gray-400 border-solid items-center min-h-90 no-underline'
        >
          <div className='mr-12'>
            <img src={PointsSvg} alt='Rewards' width={40} />
          </div>
          <p className='text-13'>
            <strong>
              {SHORT_SITE_NAME} {t('rewards', 'Rewards')}
            </strong>
            <br />
            {t('description.rewards', 'Earn one point for every dollar you spend.')}
            <br />
            <strong>{t('points', { defaultValue: '{{count}} points', count: 150 })} = </strong>
            <strong>$10 {t('reward', 'Reward')}.</strong>
          </p>
        </Link>
        <Link
          to={CREDITS_URL}
          className='flex w-350 max-w-full m-10 p-10 border border-gray-400 border-solid items-center min-h-90 no-underline'
        >
          <div className='mr-12'>
            <img src={CreditsSvg} alt='Credits' width={40} height={40} />
          </div>
          <p className='text-13'>
            <strong>{t('title.stockUpOnCredits', 'Stock up on Credits')}</strong>
            <br />
            {t('description.creditsSaveMoneyButBulk', 'Save money and get free bonus credits when you buy in bulk.')}
          </p>
        </Link>
        <Link
          to={PROFILE_PATTERN_PACKS_URL}
          className='flex w-350 max-w-full m-10 p-10 border border-gray-400 border-solid items-center min-h-90 no-underline'
        >
          <div className='mr-12'>
            <img src={PatternPacksSvg} alt='Rewards' width={40} />
          </div>
          <p className='text-13'>
            <strong>{t('title.patternPacks', 'Stock up on Pattern Packs')}</strong>
            <br />
            {t('description.patternPacksSaveMoneyBuyBulk', 'Save money when you buy in bulk.')}
          </p>
        </Link>
      </div>
    </section>
  )
}

export default SpecialFeatures
